import { useQuery } from '@tanstack/react-query';
import { getAllTimezones } from '@uplift/api';
import { UserRole } from '@uplift/types';


export const useAllTimezonesQuery = (role?: UserRole) => useQuery({
  queryKey: [ 'all-timezones', role ],
  queryFn: async () => {
    const response = await getAllTimezones(role);

    return response.data;
  }
});
